import { motion } from "framer-motion";
import { Instagram, Mail, MessageCircle, Youtube } from "lucide-react";
import { CONTACT, LOGOS, SOCIAL } from "@/data/content";
import { Kicker, Reveal, Star } from "./Reveal";

const BigBtn = ({ href, icon: Icon, label, value, testid, bg, shadow }) => (
  <motion.a
    href={href}
    target="_blank"
    rel="noopener noreferrer"
    whileHover={{ y: -6 }}
    whileTap={{ y: 2 }}
    data-testid={testid}
    className="group flex items-center gap-4 rounded-[2rem] p-5 text-white sm:p-6"
    style={{ background: bg, boxShadow: `0 8px 0 ${shadow}` }}
  >
    <span className="grid h-14 w-14 shrink-0 place-items-center rounded-2xl bg-white/20 transition-transform duration-500 group-hover:rotate-12">
      <Icon className="h-7 w-7" />
    </span>
    <span className="min-w-0">
      <span className="font-mono-label block text-xs uppercase tracking-[0.18em] text-white/85">{label}</span>
      <span className="font-display block break-all text-xl font-extrabold sm:text-2xl">{value}</span>
    </span>
  </motion.a>
);

export const Contact = () => (
  <section id="contato" className="felt relative overflow-hidden bg-[var(--red)] px-5 py-24 text-white sm:px-8 sm:py-32" data-testid="contact-section">
    <Youtube className="floaty absolute left-[6%] top-12 h-14 w-14 text-white" strokeWidth={2.2} data-testid="contact-youtube-floater" />
    <Star className="floaty absolute bottom-16 right-[10%] h-16 w-16" />
    <div className="mx-auto grid max-w-6xl items-center gap-12 lg:grid-cols-12">
      <Reveal className="lg:col-span-6">
        <Kicker className="text-white/85">Contato & parcerias</Kicker>
        <h2 className="font-display mt-3 text-6xl font-extrabold leading-[0.9] sm:text-7xl">Fale com a gente!</h2>
        <p className="mt-5 max-w-md text-base text-white/90 sm:text-lg">
          Estamos prontos para mostrar o melhor do seu espaço, parque, hotel, viagem ou produto, de forma natural e atemporal.
        </p>
        <div className="mt-8 grid gap-5">
          <BigBtn href={CONTACT.whatsapp} icon={MessageCircle} label="WhatsApp / Telefone" value={CONTACT.phone} testid="contact-whatsapp-direct-button" bg="#1fa855" shadow="#0f6e33" />
          <BigBtn href={CONTACT.mailto} icon={Mail} label="E-mail comercial" value={CONTACT.email} testid="contact-email-direct-button" bg="var(--blue)" shadow="var(--blue-deep)" />
        </div>
      </Reveal>
      <Reveal delay={0.15} className="lg:col-span-6">
        <motion.img
          src={LOGOS.familia}
          alt="Família Pedro Clube Show"
          whileHover={{ rotate: 3, scale: 1.03 }}
          className="mx-auto w-full max-w-md -rotate-3 drop-shadow-[0_30px_40px_rgba(0,0,0,0.3)]"
        />
      </Reveal>
    </div>
  </section>
);

export const Footer = () => (
  <footer className="bg-[var(--ink)] px-5 py-12 text-white sm:px-8" data-testid="site-footer">
    <div className="mx-auto flex max-w-6xl flex-col items-start justify-between gap-8 md:flex-row md:items-center">
      <div className="flex items-center gap-4">
        <img src={LOGOS.show} alt="Pedro Clube Show" className="h-14 w-auto" />
        <img src={LOGOS.familia} alt="Família Pedro Clube Show" className="h-14 w-auto" />
        <img src={LOGOS.games} alt="Pedro Clube Games" className="h-14 w-auto" />
      </div>
      <div className="flex flex-wrap gap-2">
        {[
          { h: SOCIAL.ytShow, I: Youtube, t: "YT @pedroclubeshow", id: "footer-yt-show" },
          { h: SOCIAL.ytFamilia, I: Youtube, t: "YT @familiapedroclubeshow", id: "footer-yt-familia" },
          { h: SOCIAL.ytGames, I: Youtube, t: "YT @pedroclubegames", id: "footer-yt-games" },
          { h: SOCIAL.igShow, I: Instagram, t: "IG @pedroclubeshow", id: "footer-ig-show" },
          { h: SOCIAL.igFamilia, I: Instagram, t: "IG @familiapedroclubeshow", id: "footer-ig-familia" },
        ].map(({ h, I, t, id }) => (
          <a key={id} href={h} target="_blank" rel="noopener noreferrer" data-testid={id} className="inline-flex items-center gap-2 rounded-full border border-white/20 px-3 py-2 text-xs font-semibold text-white/90 transition-colors duration-300 hover:bg-white hover:text-[var(--ink)]">
            <I className="h-4 w-4" /> {t}
          </a>
        ))}
      </div>
    </div>
    <p className="mx-auto mt-10 max-w-6xl text-xs text-white/60">© 2026 Pedro Clube Show · Diego, Dani & Pedro · Porto Alegre, RS</p>
  </footer>
);
